export const BANK_CONFIG: Record<number, {
	maxLength: number;
	format: (v: string) => string;
}> = {
	// ACLEDA
	2: {
		maxLength: 14,
		format: (v: string) => {
			return [
				v.substring(0, 4),
				v.substring(4, 6),
				v.substring(6, 12),
				v.substring(12, 14)
			].filter(Boolean).join('-');
		}
	},

	// CANADIA
	3: {
		maxLength: 13,
		format: (v: string) => {
			return [
				v.substring(0, 4),
				v.substring(4, 8),
				v.substring(8, 13)
			].filter(Boolean).join('-');
		}
	},

	// WING
	4: {
		maxLength: 8,
		format: (v: string) => v
	}
};
